import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import { NAV_LINKS } from '../../data/mock';

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="w-full bg-white border-b border-black/5 sticky top-0 z-40">
      <div className="max-w-[1280px] mx-auto flex items-center justify-between px-6 py-5">
        <Logo />

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              end={link.path === '/'}
              className={({ isActive }) =>
                `text-[12px] tracking-[0.22em] font-medium transition-colors duration-200 relative py-1 ${
                  isActive ? 'text-[#1c1e20]' : 'text-[#3c3c3c] hover:text-[#1c1e20]'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {link.label}
                  {isActive && (
                    <span className="absolute -bottom-1 left-0 right-0 h-[2px] bg-[#c9a961]" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </nav>

        <button
          className="lg:hidden text-[#1c1e20]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-black/5 bg-white">
          <nav className="flex flex-col px-6 py-4">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.path === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 text-[13px] tracking-[0.22em] font-medium border-b border-black/5 ${
                    isActive ? 'text-[#c9a961]' : 'text-[#3c3c3c]'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
